module.exports = __webpack_public_path__ + "img/nomado-trunk.f986d8e9.svg";